const slugify = string =>
  string
    .replace(/[^a-z0-9 -]/gi, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

export default slugify;
